import urlBase from 'EstruturaAntiga/assets/urlsBase';
import BaseService from './BaseService';

class PortalClienteService extends BaseService {
  constructor() {
    super(urlBase.urlBase);
  }
}

export default PortalClienteService;